import gql from 'graphql-tag'

const statsAgentiTable = gql`
  query statsAgentiTable(
    $mese: Int!, 
    $anno: Int!
  ) {
    statsAgentiTable(
      mese: $mese, 
      anno: $anno
    ) {
      idAgente
      nomeAgente
      numeroTelefonateOut
      numeroEmailOut
      numeroWhatsappOut
      numeroClientiAssegnati
      numeroAppuntamentiSaltatiAnnullati
      numeroAppuntamentiStatoFissatoAgente
      numeroAppuntamentiStatoConfermatoSegretaria
      numeroAppuntamentiStatoFatto
      numeroAppuntamentiStatoConfermatoCliente
      mediaVotiAppuntamento
      mediaVotiContatto
    }
  }
`

export default statsAgentiTable


// WEBPACK FOOTER //
// ./src/graphql/queries/statsAgentiTable.js